<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu
      side="start"
      contentId="main-content"
      [class.ion-hide]="!(isLoggedIn$ | async)"
    >
      <ion-header translucent>
        <ion-toolbar>
          <ion-title>
            <svg
              height="100%"
              width="100%"
              style="max-height: 1em"
              viewBox="0 0 760 89"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.16048 9.77224V79.5904H18.1832V29.0336H18.8309L39.4218 79.4882H47.74L68.3309 29.0677H68.9787V79.5904H79.0014V9.77224H66.2173L43.99 64.045H43.1718L20.9446 9.77224H8.16048ZM97.3345 79.5904L103.744 61.1132H131.016L137.391 79.5904H148.573L123.448 9.77224H111.278L86.1526 79.5904H97.3345ZM106.812 52.2495L117.107 22.4541H117.653L127.948 52.2495H106.812ZM143.989 18.8404H165.739V79.5904H176.239V18.8404H198.023V9.77224H143.989V18.8404ZM207.083 79.5904H251.265V70.5222H217.617V49.1472H248.572V40.1132H217.617V18.8404H250.856V9.77224H207.083V79.5904ZM262.047 79.5904H272.581V53.17H286.899C287.138 53.17 287.342 53.17 287.581 53.17L301.763 79.5904H313.763L298.285 51.3291C306.842 48.1586 311.104 41.0336 311.104 31.6586C311.104 18.8063 303.126 9.77224 286.933 9.77224H262.047V79.5904ZM272.581 44.1018V18.8063H285.808C296.206 18.8063 300.501 23.7495 300.501 31.6586C300.501 39.5336 296.206 44.1018 285.944 44.1018H272.581ZM331.576 9.77224H321.042V79.5904H331.576V9.77224ZM349.934 79.5904L356.344 61.1132H383.616L389.991 79.5904H401.173L376.048 9.77224H363.878L338.753 79.5904H349.934ZM359.412 52.2495L369.707 22.4541H370.253L380.548 52.2495H359.412ZM408.375 79.5904H450.546V70.5222H418.91V9.77224H408.375V79.5904ZM529.459 31.8291H540.266C537.914 18.2268 526.289 8.81769 511.221 8.81769C493.152 8.81769 479.959 22.42 479.959 44.7154C479.959 66.8063 492.777 80.545 511.698 80.545C528.641 80.545 540.743 69.4313 540.743 51.8063V43.8632H513.3V52.5563H530.55C530.311 63.8063 522.88 70.9313 511.698 70.9313C499.391 70.9313 490.425 61.6245 490.425 44.6472C490.425 27.7381 499.459 18.4313 511.289 18.4313C520.561 18.4313 526.834 23.545 529.459 31.8291ZM596.133 9.77224V54.8404C596.133 64.3177 589.588 71.1359 578.951 71.1359C568.349 71.1359 561.77 64.3177 561.77 54.8404V9.77224H551.236V55.6927C551.236 70.3518 562.213 80.7495 578.951 80.7495C595.69 80.7495 606.701 70.3518 606.701 55.6927V9.77224H596.133ZM629.671 9.77224H619.137V79.5904H629.671V9.77224ZM664.734 79.5904C686.007 79.5904 698.314 66.3972 698.314 44.5791C698.314 22.8631 686.007 9.77224 665.45 9.77224H642.132V79.5904H664.734ZM652.666 70.3859V18.9768H664.802C680.075 18.9768 687.95 28.1131 687.95 44.5791C687.95 61.1132 680.075 70.3859 664.154 70.3859H652.666ZM708.533 79.5904H752.715V70.5222H719.067V49.1472H750.022V40.1132H719.067V18.8404H752.306V9.77224H708.533V79.5904Z"
                fill="black"
              />
            </svg>
          </ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-menu-toggle autoHide="false">
          <ion-fab vertical="center" horizontal="center" slot="fixed">
            <ion-fab-button>
              <ion-icon name="add"></ion-icon>
            </ion-fab-button>
          </ion-fab>
          <ion-list>
            <ion-item
              lines="full"
              routerLink="/intro"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="home-outline"></ion-icon>
              <ion-label>Home</ion-label>
            </ion-item>
            <ion-item
              lines="full"
              routerLink="/products"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="cart-outline"></ion-icon>
              <ion-label> Produkte </ion-label>
            </ion-item>
            <ion-item
              lines="full"
              routerLink="/actions"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="play-outline"></ion-icon>
              <ion-label> Aufgaben </ion-label>
            </ion-item>
            <ion-item
              lines="full"
              routerLink="/batches"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="receipt-outline"></ion-icon>
              <ion-label> Chargen </ion-label>
            </ion-item>

            <ion-item-divider>
              <ion-label> Einstellungen </ion-label>
            </ion-item-divider>
            <ion-item
              lines="full"
              routerLink="/resources"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="fast-food-outline"></ion-icon>
              <ion-label> Ressourcen </ion-label>
            </ion-item>
            <ion-item
              lines="full"
              routerLink="/categories"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="pricetags-outline"></ion-icon>
              <ion-label> Kategorien </ion-label>
            </ion-item>

            <ion-item
              *ngIf="isAdmin$ | async"
              lines="full"
              routerLink="/springboard"
              routerLinkActive="active"
            >
              <ion-icon slot="start" name="apps-outline"></ion-icon>
              <ion-label> <em>Admin Springboard</em></ion-label>
            </ion-item>
            <ion-item lines="none">
              <ion-badge slot="end" class="ion-margin-horizontal" color="light">
                v{{ SCHEMA_VERSION }}
              </ion-badge>
            </ion-item>
          </ion-list>
        </ion-menu-toggle>
      </ion-content>
      <ion-footer>
        <ion-toolbar class="ion-text-center">
          <ion-grid>
            <ion-row class="ion-justify-content-center">
              <ion-col class="ion-text-center ion-padding-top">
                <ion-img
                  *ngIf="
                    (producer$ | async)?.data?.producer
                      ?.producerLogo[0] as logo;
                    else noLogo
                  "
                  class="producer--logo"
                  [src]="logo.url"
                ></ion-img>
                <ng-template #noLogo>
                  <ion-text
                    [innerText]="(producer$ | async)?.data?.producer?.title"
                  ></ion-text>
                </ng-template>
              </ion-col>
            </ion-row>
          </ion-grid>

          <ion-button
            *ngIf="isAdmin$ | async"
            class="ion-margin"
            expand="block"
            size="small"
            (click)="presentSwitchProducerModal()"
          >
            <ion-icon slot="start" name="swap-horizontal-outline"></ion-icon>
            <ion-label>Hersteller wechseln</ion-label>
          </ion-button>

          <ion-button
            color="danger"
            class="ion-margin"
            expand="block"
            size="small"
            (click)="logout()"
          >
            <ion-label>Logout</ion-label>
            <ion-icon name="log-out-outline" size="small" slot="end"></ion-icon>
          </ion-button>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
